<template>
  <AppWithLoading :fetch="setIsTestValue">
    <div>
      <VRow justify="center">
        <VCol v-if="$vuetify.breakpoint.smAndDown" cols="12" md="3" xl="2">
          <CompanySmallCard :company="company" />
        </VCol>
        <VCol cols="12" md="8" xl="6">
          <VRow v-if="!isTest" justify="center">
            <VCol cols="12" lg="10">
              <h1 class="headline text-center">
                {{ $t('success') }}
              </h1>
              <div class="text-center mt-2 mt-md-0">
                {{ $t('successTip') }}
              </div>
            </VCol>
            <VCol v-if="vacancy.faq && vacancy.faq.length > 0" cols="12" lg="10">
              <VCard elevation="1" class="pa-3 pa-md-5 px-md-12 pt-md-5 mb-5 mt-4">
                <h2 class="title font-regular">
                  {{ $t('FAQ') }} &laquo;{{ vacancy.title }}&raquo;
                </h2>
                <VacancyFaq :faq="vacancy.faq" class="mt-2" />
              </VCard>
            </VCol>
          </VRow>
        </VCol>
      </VRow>
      <VRow justify="center">
        <VCol
          v-if="!$route.meta.iframe"
          v-show="$vuetify.breakpoint.mdAndUp"
          cols="12"
          md="3"
          xl="2"
        >
          <CompanySmallCard :company="company" />
        </VCol>
        <VCol cols="12" md="8" xl="6">
          <div v-if="isTest">
            <VCard elevation="1" class="pa-3 pa-md-5 px-md-12 pt-md-5 mb-5">
              <h2 v-if="!emailChanged" class="title font-weight-regular mt-5 mb-3">
                {{ $t('email') }}
              </h2>
              <div class="mb-5">
                <div v-if="!emailChanged">
                  <TestCandidateEmailForm :candidate="candidate" @done="emailChanged = true" />
                </div>
                <div v-else>
                  <span>
                    {{ $t('emailSaved') }}
                  </span>
                </div>
              </div>
            </VCard>
          </div>
          <VCard v-if="!$route.meta.iframe" elevation="1" class="pa-3 pa-md-5 px-md-12 pt-md-5 mb-5">
            <div class="primary--text ml-md-n5">
              <span>&larr; </span>
              <RouterLink :to="{ name: 'vacancy', params: { vacancyId: vacancy.id } }" class="body-2">
                {{ $t('vacancyDesription') }}
              </RouterLink>
            </div>
          </VCard>
          <VCard elevation="1" class="pa-3 pa-md-12 px-md-12 mb-5">
            <h2 class="title font-weight-regular mb-4">
              {{ $t('rate') }}
            </h2>
            <FeedbackForm />
          </VCard>
        </VCol>
      </VRow>
    </div>
  </AppWithLoading>
</template>

<script>
import { mapGetters } from 'vuex';
import VacancyFaq from '../Vacancy/VacancyFaq.vue';
import FeedbackForm from '../../forms/FeedbackForm.vue';
import CompanySmallCard from '../Company/CompanySmallCard.vue';
import { candidateStatuses } from '../../enums';
import TestCandidateEmailForm from '../../forms/TestCandidateEmailForm.vue';
import useTestInterview from '../../compositions/useTestInterview';
import AppWithLoading from '../AppWithLoading.vue';

export default {
  name: 'InterviewDone',
  components: {
    AppWithLoading,
    TestCandidateEmailForm,
    FeedbackForm,
    VacancyFaq,
    CompanySmallCard,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isTest: null,
      emailChanged: false,
    };
  },
  computed: {
    ...mapGetters('candidate', ['candidate']),
    isPassedDemo() {
      return this.candidate.status === candidateStatuses.PASSED_DEMO_INTERVIEW;
    },
  },
  async created() {
    await this.$store.dispatch('candidate/fetchData', { vacancyId: this.vacancy.id });
  },
  methods: {
    async setIsTestValue() {
      this.isTest = await this.isTestFunc(this.vacancy.id);
    },
  },
  setup() {
    const { isTest } = useTestInterview();

    return {
      isTestFunc: isTest,
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  thanks: Thank you for your time
  seeYou: The employer will contact you later
  vacancyDesription: Job description
  FAQ: Job FAQ
  rate: Please rate our service
  emailSaved: Thanks. You will receive an email shortly.
  email: Enter an email to receive a link to your recording.
  success: You have completed the interview
  successTip: You will be contacted after your interview is reviewed
</i18n>

<i18n locale="ru" lang="yaml">
  thanks: Спасибо за уделенное время
  seeYou: С вами свяжутся после просмотра интервью
  vacancyDesription: Описание вакансии
  FAQ: Часто задаваемые вопросы о вакансии
  rate: Оцените сервис
  emailSaved: Спасибо. Скоро вы получите письмо.
  email: Укажите свой email, чтобы получить ссылку на свою запись.
  success: Интервью пройдено!
  successTip: С вами свяжутся после ознакомления с вашим интервью
</i18n>
